import {
  ORDER_STATUS_DESCRIPTIONS,
  ORDER_STATUS_LABELS,
  PAYMENT_STATUS_LABELS,
  isNoCharge,
  paymentStatusLabel,
  type OrderStatus,
  type PaymentStatus,
} from '@oficina/shared';
import { PAYMENT_STYLE, STATUS_STYLE } from '@/lib/status-style';
import { cn } from '@/lib/utils';

export function StatusBadge({ status, className }: { status: OrderStatus; className?: string }) {
  const style = STATUS_STYLE[status];
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold leading-none',
        className,
      )}
      style={{ background: style.bg, color: style.fg }}
      title={ORDER_STATUS_DESCRIPTIONS[status]}
    >
      {ORDER_STATUS_LABELS[status]}
    </span>
  );
}

export function PaymentBadge({ status, total, orderStatus, className }: { status: PaymentStatus; total?: number; orderStatus?: OrderStatus; className?: string }) {
  const noCharge = total !== undefined && isNoCharge(total, status, orderStatus);
  const style = noCharge ? { bg: '#edf0f0', fg: '#617074' } : PAYMENT_STYLE[status];
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold leading-none',
        className,
      )}
      style={{ background: style.bg, color: style.fg }}
    >
      {total === undefined ? PAYMENT_STATUS_LABELS[status] : paymentStatusLabel(status, total, orderStatus)}
    </span>
  );
}
